const OWNER = 'SwarmMarkets'
const REPOSITORY = 'smt-rewards-distribution'
const TREE_SHA = 'main'

export default { OWNER, REPOSITORY, TREE_SHA }
